import type { ApprovalContextTablesConfig } from '../../types';

export const approvalContextTables: ApprovalContextTablesConfig = {
  tableIds: ['reward-history', 'reward-totals'],
  showSectionBreak: true,
};

export default approvalContextTables;
